<template>
  <div
    class="pagination"
  >
    <button
      v-if="getCurrentPageNumber > 1 && getTotalNumOfPages > 5"
      class="pagination__item"
      @click="prevPage"
    >
      <Arrow class="arrow--prev" />
    </button>
    <PaginationButton
      v-for="page in getPages"
      :key="page"
      :page-number="page"
      class="pagination__item"
      @getPageNumber="displayPageResults"
    />
    <button
      v-if="(getCurrentPageNumber <= getTotalNumOfPages) && (getTotalResults > (getCurrentPageNumber * 10)) && getTotalNumOfPages > 5"
      class="pagination__item pagination__item--arrow"
      @click="nextPage"
    >
      <Arrow />
    </button>
  </div>
</template>

<script>
import PaginationButton from '@/components/subcomponents/pagination/PaginationButton.vue'
import Arrow from '@/components/subcomponents/svg/Arrow.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Pagination',
  components: {
    PaginationButton,
    Arrow
  },
  computed: {
    ...mapGetters({
      getCurrentPageNumber: 'pageNumber/getCurrent',
      getTotalResults: 'results/getNumOfResults'
    }),
    getPages () {
      let pages = []
      const paginationLimit = 5
      const currentPage = this.getCurrentPageNumber
      const numOfPages = this.getTotalNumOfPages
      let lowerPaginationLimit = (Math.floor(currentPage / paginationLimit) * paginationLimit) + 1
      const upperPaginationLimit = (Math.ceil(currentPage / paginationLimit) * paginationLimit) + 1

      // This accounts for multiples of five in which the lower and upper limit are the same
      if (lowerPaginationLimit === upperPaginationLimit) lowerPaginationLimit = lowerPaginationLimit - 5

      for (let i = 1; i <= numOfPages; i++) pages[i] = i

      this.handleActivePage()

      return pages.slice(lowerPaginationLimit, upperPaginationLimit)
    },
    getTotalNumOfPages () {
      return Math.ceil(this.getTotalResults / 10)
    }
  },
  watch: {
    getPages () {
      this.$nextTick(() => {
        this.handleActivePage()
      })
    }
  },
  mounted () {
    this.handleActivePage()
  },
  methods: {
    prevPage () {
      this.$store.commit('pageNumber/decrement')
      window.scrollTo(0, 0)
    },
    nextPage () {
      this.$store.commit('pageNumber/increment')
      window.scrollTo(0, 0)
    },
    displayPageResults (pageNumber) {
      this.$store.commit('pageNumber/setPage', pageNumber)
    },
    handleActivePage () {
      const pageNumber = this.getCurrentPageNumber
      const pageBtns = document.querySelectorAll('.pagination__item')

      if (pageBtns) {
        pageBtns.forEach(btn => {
          btn.classList.remove('pagination__item--active')

          if (btn.innerText === pageNumber.toString()) btn.classList.add('pagination__item--active')
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
@use 'mixins' as *;
@use 'variables';

.pagination {
  display: flex;
  padding: 0;
  z-index: 0;
  justify-content: center;
  margin-top: 0.5rem;

  @include breakpoint-md {
    justify-content: flex-end;
  }

  &__item {
    font-size: 1em;
    font-weight: 600;
    border: 1px solid #ddd;
    width: 40px;
    height: 40px;
    text-align: center;
    background-color: variables.$color-white;
    border-radius: 4px;
    margin-left: 8px;
    cursor: pointer;
    outline: none;

    &--active {
      border: 1px solid variables.$color-brand;
    }
  }
}

.arrow {
  &--prev {
    transform: rotate(180deg);
  }
}

.careers-component .pagination {
  display: none;
}
</style>
